import Mustache from 'mustache';
import { t } from '../../utils/i18n';

class Tickets {
  constructor(template) {
    this.template = template;

    Mustache.parse(this.template);
  }

  membershipBenefits = (membership) => {
    const childText = membership.childText ? `, ${membership.childText}` : '';
    const guestText = membership.guestText ? `${membership.guestText}` : '';
    return `${membership.adultText}${guestText}${childText}${t('js.upsell.benefits_suffix')}`;
  };

  render({ priceDifference, name, ...membership }) {
    const price = parseFloat(membership.price);
    const context = {
      ...membership,
      title: t('js.upsell.title', { name: name }),
      benefits: this.membershipBenefits(membership),
      price: `$${price.toFixed(2)}`,
    };

    if (priceDifference) {
      if (priceDifference > 0) {
        context.priceDifference = t('js.upsell.for_only', {
          amount: priceDifference,
        });
      } else {
        context.priceDifference = t('js.upsell.for_less', {
          amount: Math.abs(priceDifference),
        });
      }
    }

    return Mustache.render(this.template, context);
  }
}

class TimedTickets {
  constructor(template) {
    this.template = template;

    Mustache.parse(this.template);
  }

  membershipBenefits = (membership) => {
    const childText = membership.childText ? `, ${membership.childText}` : '';
    const guestText = membership.guestText ? `${membership.guestText}` : '';
    return `${membership.adultText}${guestText}${childText}.`;
  };

  render({ priceDifference, name, ...membership }) {
    const price = parseFloat(membership.price);
    const context = {
      ...membership,
      title: t('js.upsell.title', { name: name }),
      benefits: this.membershipBenefits(membership),
      price: `$${price.toFixed(0)}`,
    };

    if (priceDifference) {
      if (priceDifference > 0) {
        context.priceDifference = t('js.upsell.for_only_enjoy', {
          amount: priceDifference,
        });
      } else {
        context.priceDifference = t('js.upsell.for_less_enjoy', {
          amount: Math.abs(priceDifference),
        });
      }
    }

    return Mustache.render(this.template, context);
  }
}

export { Tickets, TimedTickets };
